import { Component, Input } from '@angular/core';
import { CarrierId, SCV2_CARRIERS } from '../../shipping-config-v2.service';

@Component({
  selector: 'app-carrier-mark-v2',
  templateUrl: './carrier-mark-v2.component.html',
  styleUrls: ['./carrier-mark-v2.component.scss'],
})
export class CarrierMarkV2Component {
  @Input() carrierId: CarrierId = 'ups';
  @Input() size = 40;

  get color(): string {
    return SCV2_CARRIERS[this.carrierId]?.color || '#333';
  }

  get text(): string {
    return this.carrierId === 'ups' ? 'UPS' : 'US';
  }
}
